import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

// manor
import { Button } from '@comparethemarketau/manor-button';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';

import { withHandoverUrl } from './with_handover_url';
import { withQuoteFlatten } from './with_quote_flatten';

import { HandoverWizardModal } from './handover_wizard_modal';
import { getHandoverWizardPages, isSupportHandoverWizard } from '../brand_customization/handover_wizard_pages';

const useStyles = createUseStyles((theme) => ({
    button: {
        marginBottom: 0
    }
}));

const _ProceedWithProvider = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const {
        buttonText,
        buttonClassName,
        productId,
        providerName,
        providerCode,
        productAvailable,
        handoverUrl,
        productDisclosures,
        customerHandover
    } = props;
    const handover = () => {
        if (handoverUrl) {
            // eslint-disable-next-line security/detect-non-literal-fs-filename
            window.open(handoverUrl);
        }
    };

    const handleClick = () => {
        if (!isSupportHandoverWizard(providerCode)) {
            // eslint-disable-next-line security/detect-non-literal-fs-filename
            handover();
            return;
        }
        customerHandover(providerCode);
    };

    return productAvailable ? (
        <div className={classNames('test-policyProductCard-proceedWithProvider')}>
            <Button
                id={`proceed-button-for-${productId}`}
                trackingLabel={`Proceed with ${providerName} for ${productId}`}
                variant="primary"
                icon={faExternalLink}
                iconAlign="right"
                handleClick={handleClick}
                className={classNames(classes.button, buttonClassName)}
            >
                {buttonText
                    || `Proceed with ${providerNameTruncate(providerCode, providerName)}`}
            </Button>
            {
                isSupportHandoverWizard(providerCode)
                && (
                    <HandoverWizardModal
                        onCompeleted={handover}
                        providerCode={providerCode}
                        pages={getHandoverWizardPages(providerCode, productDisclosures)}
                    />
                )
            }
        </div>
    ) : null;
};

_ProceedWithProvider.propTypes = {
    buttonText: PropTypes.string,
    buttonClassName: PropTypes.string,
    quote: PropTypes.object.isRequired,
    /**
   * for get url from withHandoverUrl
   */
    currentIndex: PropTypes.number,
    productId: PropTypes.string,
    providerName: PropTypes.string,
    providerCode: PropTypes.string,
    productDisclosures: PropTypes.object,
    productAvailable: PropTypes.bool,
    productAvailableOnline: PropTypes.bool,
    handoverUrl: PropTypes.string,
    customerHandover: PropTypes.func
};

const mapDispatchToProps = (dispatch) => ({
    customerHandover: (providerCode) => {
        dispatch({
            type: 'SET_PAGE_VALUE',
            identifier: `customerHandoverModal_${providerCode}`,
            value: true
        });
    }
});

const ProceedWithProvider = withQuoteFlatten(
    withHandoverUrl(
        connect(null, mapDispatchToProps)(_ProceedWithProvider)
    )
);

export { ProceedWithProvider };

const providerNameTruncate = (providerCode, providerName) => {
    if (providerCode === 'WOOL') {
        return 'Everyday';
    }
    return providerName;
};
